<template>
  <div
    v-if="userHasPermission(constants.PERMISSION_TYPES.EVENT, constants.PERMISSION_VALUES.LIST) || timelineData"
    :class="{'spl-parcel-timeline-summary': summary}"
    class="spl-parcel-timeline">
    <div v-if="summary" class="spl-parcel-timeline-summary__label">
      Original timeline
    </div>
    <div
      :class="{'spl-parcel-timeline__track-deadline-missed': deadlineMissed}"
      :style="{'width': 'calc(100% - 140px)'}"
      class="spl-parcel-timeline__track">
      <div
        v-for="(point, index) in timelinePoints"
        :key="'parelTimeLinePoint' + index"
        :class="{
          'spl-parcel-timeline__track__dot-red': point.delayed,
          'spl-parcel-timeline__track__dot-deadline': point.deadline,
          'spl-parcel-timeline__track__dot-diamond': isDiamond(index),
          'spl-parcel-timeline__track__dot-current': isCurrent(index)
        }"
        :style="{'left': point.percentage + '%'}"
        class="spl-parcel-timeline__track__dot">
        <div v-if="isCurrent(index)" class="spl-parcel-timeline__track__dot__pulse" />
        <div v-if="!summary" class="spl-parcel-timeline__track__dot__info">
          <div class="spl-parcel-timeline__track__dot__info__label">
            {{ point.label }}
          </div>
          <div class="spl-parcel-timeline__track__dot__info__timestamp">
            {{ formatDate(point.timestamp, true,'YYYY-MM-DD HH:mm') }}
          </div>
        </div>
      </div>
      <div
        v-for="(point, index) in filteredTimeLinePoints"
        :key="'parcelTimelinePoint2' + index"
        :class="{'spl-parcel-timeline__track__line-red': isRedLined(index)}"
        :style="{
          'left': point.percentage + '%',
          'width': lineWidth(index) + '%'
        }"
        class="spl-parcel-timeline__track__line" />
    </div>
    <div
      :class="{'spl-parcel-timeline__deadline-zone-deadline-missed': deadlineMissed}"
      :style="{'width': 'calc(' + deadlineWidth / 100 + ' * calc(100% - 140px) + 100px)'}"
      class="spl-parcel-timeline__deadline-zone" />
  </div>
</template>

<script>
import Helpers from '@/helpers'
import webApi from '@/webApi'
import constants from '@/constants'
import { filter } from 'lodash'

export default {
  name: 'ParcelTimeline',
  mixins: [Helpers],
  props: ['timelineData', 'summary', 'parcelKey', 'reload'],
  data () {
    return {
      minDotDistance: 6,
      maxDotDistance: 30,
      lastIndex: -1,
      currentIndex: -1,
      deadlineIndex: -1,
      deadlineMissed: false,
      timelinePoints: [],
      constants
    }
  },
  computed: {
    /// ***************************************************************
    /// CALCULATES THE WIDTH OF THE TIMELINE IN %
    trackWidth () {
      var w = 100

      if (this.deadlineMissed) {
        w = this.timelinePoints[this.deadlineIndex].percentage
      }
      return w
    },

    /// ***************************************************************
    /// CALCULATES THE DEADLINE POSITION IN %
    deadlineWidth () {
      return 100 - this.trackWidth
    },
    filteredTimeLinePoints () {
      return filter(this.timelinePoints, (element, index) => {
        return index < this.currentIndex
      })
    }
  },
  watch: {
    reload: function (newVal, oldVal) {
      // watch it
      if (newVal === true) {
        this.get_Parcel_Time_Line()
      }
    },
    timelineData: {
      handler: function () {
        this.prepareData(this.timelineData)
      },
      deep: true
    }
  },
  mounted () {
    /// ***************************************************************
    /// lOOKS FOR THE DIFFERENT IMPORTANT MILESTONES
    this.get_Parcel_Time_Line()
  },
  methods: {
    /// ***************************************************************
    /// CALCULATES THE DISTANCE BETWEEN 2 DOTS.
    timelinePercentage (index) {
      var min = new Date(this.timelinePoints[0].timestamp).getTime()
      var max = new Date(this.timelinePoints[this.lastIndex].timestamp).getTime()
      var prevPercentage = index > 0 ? this.timelinePoints[index - 1].percentage : 0
      var timestampRelative = new Date(this.timelinePoints[index].timestamp).getTime() - min
      var maxRelative = max - min
      var percentage = timestampRelative / maxRelative * 100
      if (index !== 0 && prevPercentage !== 0 && percentage > prevPercentage + 40) {
        percentage = prevPercentage + 40
      }

      if (index !== 0 && percentage < prevPercentage + 5) {
        percentage = prevPercentage + 5
      }
      return percentage
    },

    normalizePercantages () {
      if (!this.timelinePoints[this.timelinePoints.length - 1]) {
        return
      }
      var maxPercent = this.timelinePoints[this.timelinePoints.length - 1].percentage

      for (var i = 0; i < this.timelinePoints.length; i++) {
        this.timelinePoints[i].percentage = 100 * (this.timelinePoints[i].percentage / maxPercent)
      }
    },
    /// ***************************************************************
    /// RETURNS TRUE IF THE TIMELINE DOT IS THE CURRENT EVENT.
    isCurrent (index) {
      return this.timelinePoints[index].current && !this.summary
    },
    /// ***************************************************************
    /// RETURNS TRUE IF THE LINE IS AFTER A DELAY
    isRedLined (index) {
      var nextDelayed = false

      if (index + 1 <= this.lastIndex) nextDelayed = this.timelinePoints[index + 1].delayed

      return (this.timelinePoints[index].delayed || this.timelinePoints[index].deadline) && nextDelayed
    },
    /// ***************************************************************
    /// CHECKS IF THE TIMELINE DOT AT INDEX IS WHERE A DELAY HAPPENED.
    isDiamond (index) {
      if (this.timelinePoints[index].current || index === 0) return false

      var prevDelayed = false
      var nextDelayed = false
      var indexDelayed = this.timelinePoints[index].delayed

      if (index - 1 >= 0) prevDelayed = this.timelinePoints[index - 1].delayed
      if (index + 1 <= this.lastIndex) nextDelayed = this.timelinePoints[index + 1].delayed

      return (indexDelayed && !prevDelayed) || (indexDelayed && !nextDelayed)
    },
    /// ***************************************************************
    /// CALCULATES THE LENGTH BETWEEN TWO TIMELINE DOTS.
    lineWidth (index) {
      if (index + 1 >= this.timelinePoints.length) {
        return 0
      } else {
        return this.timelinePoints[index + 1].percentage - this.timelinePoints[index].percentage
      }
    },
    // ************************ Get parcel timeline ************************
    // Calls the API to get the parcels timeline
    get_Parcel_Time_Line () {
      if (this.timelineData) {
        this.prepareData(this.timelineData)
      } else {
        webApi.parcel.get_Parcel_Timeline(this.parcelKey)
          .then((response) => {
            this.prepareData(response.data)
          }).catch((response) => {
            window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
          })
      }
    },
    prepareData (data) {
      // Set the the different blocks
      this.timelinePoints = []
      // Loop through the response to set all timeline points
      data.forEach((value, index) => {
        this.timelinePoints.push({
          label: value.Label,
          timestamp: value.Timestamp,
          delayed: value.Is_Delayed,
          current: value.Is_Current_Status_Event,
          deadline: value.Is_Close_Deadline
        })
      })

      this.lastIndex = this.timelinePoints.length - 1
      for (var i = 0; i < this.timelinePoints.length; i++) {
        if (this.timelinePoints[i].current) {
          this.currentIndex = i
        }
        if (this.timelinePoints[i].deadline) {
          this.deadlineIndex = i
        }
        this.timelinePoints[i].percentage = this.timelinePercentage(i)
      }
      if (this.lastIndex > this.deadlineIndex && this.deadlineIndex >= 0) {
        this.deadlineMissed = true
      }
      this.normalizePercantages()
    }
  }
}
</script>

<style lang="scss">
@import "../../variables.scss";

.spl-parcel-timeline {
  background-color: $parcelTimelineBackgroundColor;
  height: 350px;
  margin-bottom: 20px;
  position: relative;
  padding: 0 100px 0 40px;
  width: 100%;

  @include mobile() {
    height: 0;
    margin-bottom: 30px;
    overflow: hidden;
  }
  &-summary {
    background-color: $parcelTimelineSummaryBackgroundColor;
    height: 70px;
    margin-bottom: 0;

    &__label {
      color: $radioLabelText;
      font-size: 11px;
      font-weight: 600;
      position: absolute;
      transform: translate3d(-3px, 0, 0);
      top: 12px;
    }
    .spl-parcel-timeline__track__dot {
      border-color: $parcelTimelineSummaryBackgroundColor;

      &:after {
        background-color: $parcelTimelineSummaryBackgroundColor;
      }
      &-diamond {
        background-color: transparent;
        border-color: transparent;

        &:after {
          background-color: $red;
        }
      }
    }
    .spl-parcel-timeline__deadline-zone {
      background-image: url(../../assets/icon-parcel-timeline-pattern-dark.svg);

      &-deadline-missed {
        background-image: url(../../assets/icon-parcel-timeline-pattern-dark.svg), url(../../assets/icon-parcel-timeline-dashes-red.svg);
      }
    }
  }
  &__track {
    background-image: url(../../assets/icon-parcel-timeline-dash.svg);
    background-repeat: repeat-x;
    height: 3px;
    position: absolute;
    top: calc(50% - 1.5px);

    &-deadline-missed {
      .spl-parcel-timeline__track__dot-deadline {
        background-color: $red;
        margin-left: 1px;

        &:after {
          background-color: $red;
        }
        .spl-parcel-timeline__track__dot__info {
          background-image: none;
          padding: 140px 0 0 15px;

          &__label {
            color: $red;
            font-family: $opensans;
            font-size: 11px;
            letter-spacing: 0;
            text-transform: none;
          }
          &__timestamp {
            display: block;
          }
        }
      }
    }
    &__line {
      background-color: $mainInputColor;
      height: 3px;
      position: absolute;
      transform: translate3d(0, -50%, 0);
      top: 50%;

      &-red {
        background-color: $red;
      }
    }
    &__dot {
      background-color: $mainInputColor;
      border: 2px solid $parcelTimelineBackgroundColor;
      border-radius: 50%;
      height: 14px;
      position: absolute;
      transform: translate3d(-50%, -50%, 0);
      top: 50%;
      width: 14px;
      z-index: 1000;

      &:after {
        background-color: #fff;
        border-radius: 50%;
        content: "";
        height: 6px;
        left: 2px;
        position: absolute;
        transform: translate3d(0, -50%, 0);
        top: 50%;
        width: 6px;
      }
      &-deadline {
        background-color: $parcelTimelineColor;

        .spl-parcel-timeline__track__dot__info {
          background-image: none;
          padding: 0 0 0 15px;
          top: 0;

          &__label {
            color: $darkCyan;
            font-family: $mono;
            font-size: 9px;
            letter-spacing: 1px;
            text-transform: uppercase;
          }
          &__timestamp {
            display: none;
          }
        }
      }
      &-red {
        .spl-parcel-timeline__track__dot__pulse {
          border-color: $red;

          &:after {
            border-color: rgba($red, 0.15);
          }
        }
      }
      &-diamond {
        background-color: transparent;
        border-color: transparent;

        &:before,
        &:after {
          background-color: $red;
          border: 2px solid $parcelTimelineBackgroundColor;
          border-radius: 0;
          height: 10px;
          left: 5px;
          transform: translate3d(-50%, -50%, 0) rotate(45deg);
          width: 10px;
        }
        &:before {
          background-color: rgba($red, 0.6);
          border: none;
          content: "";
          height: 20px;
          position: absolute;
          top: 50%;
          width: 20px;
        }
        .spl-parcel-timeline__track__dot__info {
          background-image: url(../../assets/icon-parcel-timeline-dashes-red.svg);

          &__label {
            color: $red;
          }
        }
      }
      &-current {
        border-color: #fff;
      }
      &:nth-child(odd) &__info {
        background-position: left bottom 0px;
        bottom: 12px;
        padding: 0 0 55px 0;
        top: auto;
      }
      &:nth-child(odd).spl-parcel-timeline__track__dot-deadline &__info {
        padding: 0 0 125px 15px;
        top: -160px;
      }
      &__pulse {
        background-color: transparent;
        border: 8px solid $middleYellow;
        border-radius: 50%;
        height: 30px;
        left: 50%;
        position: absolute;
        transform: translate3d(-50%, -50%, 0);
        top: 50%;
        width: 30px;
        z-index: 1000;

        &:after {
          background-color: transparent;
          border: 8px solid rgba($middleYellow, 0.15);
          border-radius: 50%;
          content: "";
          height: 30px;
          left: 50%;
          position: absolute;
          transform: translate3d(-50%, -50%, 0);
          top: 50%;
          width: 30px;
        }
      }
      &__info {
        background-image: url(../../assets/icon-parcel-timeline-dashes.svg);
        background-position: left top 2px;
        background-repeat: no-repeat;
        padding: 51px 0 0 0;
        margin-left: 4px;
        width: 100px;
        position: absolute;
        top: 12px;

        &__label {
          color: $radioLabelText;
          font-size: 11px;
          font-weight: 600;
          margin-bottom: 3px;
        }
        &__timestamp {
          color: $parcelListControlsShowColumnsOptions;
          font-family: $mono;
          font-size: 9px;
          font-weight: 700;
        }
      }
    }
  }
  &__deadline-zone {
    background-image: url(../../assets/icon-parcel-timeline-pattern.svg);
    background-size: 5.5px 5.5px;
    height: 100%;
    position: absolute;
    right: 0;

    &-deadline-missed {
      background-image: url(../../assets/icon-parcel-timeline-pattern.svg), url(../../assets/icon-parcel-timeline-dashes-red.svg);
      background-repeat: repeat, repeat-y;
      background-size: 5.5px 5.5px, 2px 47px;
    }
    &__dot {
      background-color: $parcelTimelineColor;
      border: 2px solid $parcelTimelineBackgroundColor;
      border-radius: 50%;
      height: 14px;
      left: 1px;
      position: absolute;
      transform: translate3d(-50%, -50%, 0);
      top: 50%;
      width: 14px;

      &:after {
        background-color: #fff;
        border-radius: 50%;
        content: "";
        height: 6px;
        left: 2px;
        position: absolute;
        top: 2px;
        width: 6px;
      }
    }
    &__label {
      color: $darkCyan;
      font-family: $mono;
      font-size: 9px;
      font-weight: 700;
      left: 10px;
      letter-spacing: 1px;
      position: absolute;
      text-transform: uppercase;
      transform: translate3d(0, -50%, 0);
      top: 50%;
    }
  }
}
</style>
